<label class="custom-file-upload">
  <app-button [size]="size" [status]="status" [icon]="icon" [label]="label" (onPress)="input.click()"></app-button>
  <input #input class="input-file" type="file" [multiple]="multiple" [accept]="accept" (change)="handleFiles($event)"/>
</label>

